import { INPUT_AXIS_MAX } from "@besenliga/shared";

/** Botões, como bits de um inteiro, para viajar compactos na rede. */
export const BUTTON = {
  action: 1 << 0,
  charge: 1 << 1,
  turbo: 1 << 2,
  ability: 1 << 3,
  /** Pedir a bola (clique direito / B): o companheiro com a Pelota passa para quem pede. */
  call: 1 << 4,
} as const;

/** Comando de um atleta num tick. Eixos quantizados em [-INPUT_AXIS_MAX, INPUT_AXIS_MAX]. */
export interface InputCommand {
  x: number;
  y: number;
  z: number;
  buttons: number;
}

export const NO_INPUT: Readonly<InputCommand> = { x: 0, y: 0, z: 0, buttons: 0 };

/** Comandos de todos os atletas num tick, indexados pelo id do atleta. */
export type InputFrame = Readonly<Record<string, InputCommand>>;

/** Converte um eixo analógico em [-1, 1] para o inteiro quantizado que entra na simulação. */
export function quantizeAxis(value: number): number {
  if (!Number.isFinite(value)) return 0;
  const clamped = Math.max(-1, Math.min(1, value));
  return Math.round(clamped * INPUT_AXIS_MAX);
}

export function quantizeInput(x: number, y: number, z: number, buttons = 0): InputCommand {
  return { x: quantizeAxis(x), y: quantizeAxis(y), z: quantizeAxis(z), buttons: buttons | 0 };
}
